import React, {useState} from "react";
import TiptapEditor from "./tiptapeditor";


const sections = [
    { key: 'startseite_header', label: 'Startseite - Überschrift' },
    { key: 'startseite_text', label: 'Startseite - Begrüßungstext' },
    { key: 'kontakt_header', label: 'Kopfzeile: Kontaktinfo' },
    { key: 'impressum', label: 'Impressum' },
    { key: 'kontakt_footer', label: 'Kontaktseite' },
    { key: 'datenschutz', label: 'Datenschutz' },
    { key: 'agb', label: 'AGB'},
  ]


export default function Einstellungen() {

    const [savedHtml, setSavedHtml] = useState('')

      return (
        <div className="contentContainer">
            <br />
            <h4>Textbausteine</h4>

            {sections.map((section) => (
                <details key={section.key}>
                    <summary>{section.label}</summary>
                    <TiptapEditor fieldName={section.key} label={section.label} />
                </details>
            ))}
        </div>
  )

}

